import { useState, type FormEvent } from "react";

type FormStatus = "idle" | "loading" | "success" | "error";

interface FormResponse {
  code?: string;
  message?: string;
  meta?: { message?: string; detail?: string };
}

export default function useFormSubmit(submitAddr: string, successMessage: string) {
  const [status, setStatus] = useState<FormStatus>("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get("website_alt") || formData.get("contact_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage(successMessage);
      form.reset();
      return;
    }

    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key === "website_alt" || key === "contact_alt") return;
      const str = String(value);
      if (str.trim()) payload.append(key, str);
    });

    setStatus("loading");
    setMessage("");
    try {
      const response = await fetch(submitAddr, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: FormResponse | null = null;
      try {
        parsed = JSON.parse(responseText) as FormResponse;
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const isSpam = String(serverMsg).toLowerCase().includes("spam");

      if (response.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        setMessage(successMessage);
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg || "提交失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，提交未完成，请稍后重试。");
    }
  };

  return { status, message, handleSubmit };
}